var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.element.options !== null &&
    _vm.element.options.attrs !== null &&
    _vm.show
    ? _c("el-date-picker", {
        ref: "dateRef",
        attrs: {
          "popper-class": "coustom-date-picker" + " " + _vm.extPoperClass,
          type: _vm.componentType,
          "range-separator": _vm.$t(_vm.element.options.attrs.rangeSeparator),
          "start-placeholder": _vm.$t(
            _vm.element.options.attrs.startPlaceholder
          ),
          "end-placeholder": _vm.$t(_vm.element.options.attrs.endPlaceholder),
          placeholder: _vm.$t(_vm.element.options.attrs.placeholder),
          "append-to-body": _vm.inScreen,
          "value-format": "timestamp",
          format: _vm.labelFormat,
          size: _vm.size,
          editable: false,
          "picker-options": _vm.pickerOptions,
          "default-time": _vm.defaultRangeTime,
        },
        on: { change: _vm.dateChange, focus: _vm.toFocus, blur: _vm.onBlur },
        model: {
          value: _vm.values,
          callback: function ($$v) {
            _vm.values = $$v
          },
          expression: "values",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }